// --- LAYOUT, COMPONENTS, PARTS --- //
$(function () {
    fn_layout_main();
    fn_comp_map();
    fn_comp_slider();
    fn_comp_cards();
});

// --- MISC --- //
$(function () {
    nl_fn_smooth_scroll();
    nl_fn_footer();
    nl_fn_wsw();
    nl_fn_anchor_link();
    fn_video();
});
